import styled from 'styled-components';
import { sharedStyles } from './sharedStyles';
export var Online = styled.div.withConfig({
  displayName: "Online",
  componentId: "sc-bz08g4-0"
})(["", ";border-radius:", "px;svg{stroke:#fff;position:absolute;width:", ";height:", ";circle{fill:", ";}}"], sharedStyles, function (_ref) {
  var size = _ref.size;
  return size;
}, function (_ref2) {
  var iconSize = _ref2.iconSize;
  return "".concat(iconSize, "px");
}, function (_ref3) {
  var iconSize = _ref3.iconSize;
  return "".concat(iconSize, "px");
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.positive;
});